"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('underscore'),
  last = _require.last;
var MultilanguagePicker = /*#__PURE__*/function () {
  MultilanguagePicker.$inject = ["EventEmitter"];
  /* @ngInject */
  function MultilanguagePicker(EventEmitter) {
    _classCallCheck(this, MultilanguagePicker);
    this.EventEmitter = EventEmitter;
  }
  _createClass(MultilanguagePicker, [{
    key: "$onInit",
    value: function $onInit() {
      if (!this.model.length) {
        this.model.push('');
      }
    }
  }, {
    key: "addItem",
    value: function addItem() {
      if (last(this.model)) {
        this.model.push('');
        this.emitUpdateEvent();
      }
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(index) {
      if (this.model.length === 1) {
        this.model[0] = '';
      } else {
        this.model.splice(index, 1);
      }
      this.emitUpdateEvent();
    }
  }, {
    key: "update",
    value: function update(event, index) {
      var newLang = event.model;
      if (this.model[index] !== newLang) {
        this.model[index] = newLang;
        this.emitUpdateEvent();
      }
    }
  }, {
    key: "emitUpdateEvent",
    value: function emitUpdateEvent() {
      this.onChange(this.EventEmitter({
        languages: this.model
      }));
    }
  }]);
  return MultilanguagePicker;
}();
module.exports = angular.module('backstage.components.common.multilanguage-picker', []).component('bsMultilanguagePicker', {
  templateUrl: '/src/angular/components/common/multilanguage-picker/multilanguage-picker.html',
  bindings: {
    model: '<',
    onChange: '&'
  },
  controller: MultilanguagePicker
}).name;